import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

import { green, grey, yellow } from "@mui/material/colors";
import { GlobalState } from "context/GlobalContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Dialog, DialogActions, Divider, Switch, TablePagination, Tooltip } from "@mui/material";
import { PimDashboardState } from "context/PimDashboardContext";
import {
	attrGroupLinkedTables,
	productionStageOptions,
	productPagePath,
	publishTableColumn,
	styleImagesAssocObj,
} from "components/PimDashboard/data";
import { styleUrlKey } from "../CreateStyle/data";
import {
	converAttrToDatagridCol,
	createdByColumns,
	imageTableColumn,
	publishColumns,
	stageTableColumn,
	statusOptions,
	styleImageColumn,
} from "data/globalData";
import { FileDownloadRounded, FilterAltRounded, PlaylistAddRounded, SwapVertRounded } from "@mui/icons-material";
import FileSaver from "file-saver";
import FilterModal from "../StylesDashboard/FilterModal/FilterModal";
import AddColumnModal from "../StylesDashboard/AddColumnModal/AddColumnModal";
import { AuthState } from "context/AuthContext";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import FullScreenPopup from "./FullScreenPopup/FullScreenPopup";
import { lsFabricTrimsFilterValStr, lsStylesFilterValStr } from "../StylesDashboard/data";
import { setStylesCustomFun } from "../StylesDashboard/StylesDashboard";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const graphList = [
	{
		name: "SHIRT",
		key: "SHIRT",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "T-SHIRT",
		key: "T-SHIRT",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "POLO",
		key: "POLO",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "JACKET",
		key: "JACKET",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "DENIM PANT",
		key: "DENIM PANT",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
];

const RenderCategoryLevelGraphs = ({ list, sx = {}, ...rest }) => {
	return (
		<Box display="flex" {...rest} sx={{ overflowX: "scroll", ...sx }} columnGap={2}>
			{/* {list?.map((row) => {
				return (
					<Stack>
						<RenderStyleCountBarGraph
							width={140}
							height={120}
							xAxis={[{ data: ["SS-25", "SS-24"], scaleType: "band", categoryGapRatio: 0.4, barGapRatio: 0.2 }]}
							dataArr={row?.graphSeries}
						/>
						<Typography variant="subtitle1" fontSize={14} fontWeight={600} textAlign="center">
							{row?.name}
						</Typography>
					</Stack>
				);
			})} */}
		</Box>
	);
};
const pageLimit = 20;
const FabricAndTrims = () => {
	const { allAttributes, allAttributesObj, selectedStyle, setSelectedStyle } = PimDashboardState();
	const { user } = AuthState();
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [styles, setStyles] = useState([]);
	const [displayImg, setDisplayImg] = useState(true);
	const [selectedStyleStaticData, setSelectedStyleStaticData] = useState();
	const [tableStatusCount, setTableStatusCount] = useState({
		total: 0,
		pending: 0,
		published: 0,
	});
	const [editModal, setEditModal] = useState(false);
	const [filterModal, setFilterModal] = useState(false);
	const [addColumnModal, setAddColumnModal] = useState(false);
	const [filterColumns, setFilterColumns] = useState(
		// appling filter fron local storage data
		() => {
			let final = [];
			if (localStorage.getItem(lsFabricTrimsFilterValStr)) {
				const localStorageObj =
					typeof JSON.parse(localStorage.getItem(lsFabricTrimsFilterValStr)) === "object"
						? JSON.parse(localStorage.getItem(lsFabricTrimsFilterValStr))
						: {};
				[
					...allAttributes,
					...Object.keys(publishColumns).map((row) => publishColumns[row]),
					...createdByColumns.map((row) => converAttrToDatagridCol(row)),
					stageTableColumn(productionStageOptions),
				]?.forEach((row) => {
					if (localStorageObj?.[row?.key]) final.push(row);
				});
				return final;
			}
		}
	);
	const [filterColumnVal, setFilterColumnVal] = useState(() => {
		if (localStorage.getItem(lsFabricTrimsFilterValStr)) {
			return JSON.parse(localStorage.getItem(lsFabricTrimsFilterValStr));
		} else {
			return {};
		}
	});
	const [styleTablColumns, setStyleTaleColumns] = useState();
	const [attrColumns, setAttrColumns] = useState(() => {
		if (localStorage.getItem("fab_trims_column_Arr")) {
			return JSON.parse(localStorage.getItem("fab_trims_column_Arr"))
				?.map((row) => {
					return { ...allAttributesObj?.[row] };
				})
				.map((row) => converAttrToDatagridCol(row));
		} else
			return allAttributes
				?.filter((row) => row?.linked_table === attrGroupLinkedTables.style.key)
				?.map((row) => converAttrToDatagridCol(row));
	});
	const [offset, setOffset] = useState(0);
	const [page, setPage] = useState(0);
	const [pageSize, setPageSize] = useState(pageLimit);
	const [loading, setLoading] = useState(false);

	const handleCloseFilterModal = () => {
		setFilterModal(false);
	};
	const handleCloseAddColumnModal = () => {
		setAddColumnModal(false);
	};
	const handleFilterClick = () => {
		setFilterModal(true);
	};
	const handleAddColumnClick = () => {
		setAddColumnModal(true);
	};

	useEffect(() => {
		const fetch = async () => {
			setLoadingOpen(true);
			setStyleTaleColumns([
				imageTableColumn(styleImageColumn),
				...attrColumns,
				{
					field: "color_count",
					headerName: "Colors",
					width: 80,
					...colStyle,
				},
				...createdByColumns.map((row) => converAttrToDatagridCol(row)),
				stageTableColumn(productionStageOptions),
			]);

			try {
				fetchStyles(page, pageSize);
				setLoadingOpen(false);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
				setLoadingOpen(false);
			}
		};
		fetch();
	}, [filterColumns, attrColumns]);

	const fetchStyles = async (page, pageSize) => {
		try {
			setLoading(true);
			// convertAttrColumns to obj (they are in datagrid col format)
			const extraColumns = attrColumns?.reduce((acc, row) => {
				acc[row.field] = true;
				return acc;
			}, {});
			await axios
				.post(`/api/fabric_trims/get_styles/${page * pageSize}`, { filter: filterColumnVal, extraColumns, limit: pageSize })
				.then((res) => {
					// setStyles(setStylesCustomFun(styles, res?.data?.result.styles));
					setStyles(res?.data?.result.styles);
					setTableStatusCount(res?.data?.result.count[0]);
					setLoading(false);
				});
		} catch (err) {
			console.error("Failed to fetch styles:", err);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		fetchStyles(page, pageSize);
	}, [page, pageSize]);

	const handleImageSwitchChange = (checked) => {
		setDisplayImg(checked);
	};

	const handleStyleSelect = async (data) => {
		setLoadingOpen(true);

		try {
			await axios.get(`/api/fabric_trims/get_fabric_trims_data?styleId=${data.style_id}`).then((res) => {
				// console.log("styledata", res.data);
				setSelectedStyleStaticData(data);
				setSelectedStyle(res?.data?.result);
				setLoadingOpen(false);
				setEditModal(true);
			});
		} catch (error) {
			setLoadingOpen(false);

			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/designer/download_styles`,
				method: "GET",
				responseType: "blob",
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `allStyles.xlsx`);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	return (
		<Stack width="100%" pt={1}>
			<Box display="flex" justifyContent="space-around">
				{/* left section */}
				<Stack spacing={1} width="28%">
					<Box display="flex" columnGap={1} pt={1} flexWrap="wrap" alignItems="center">
						<Button
							variant="contained"
							size="small"
							startIcon={<FilterAltRounded />}
							onClick={handleFilterClick}
							sx={{ textTransform: "capitalize" }}>
							Filter
						</Button>{" "}
						:
						{!filterColumns?.length && (
							<Typography variant="body1" fontSize={16} color={grey[700]}>
								None
							</Typography>
						)}
						{filterColumns?.map((row) => {
							return (
								<Chip
									label={`${row.name} : ${
										Array.isArray(filterColumnVal[row?.key])
											? filterColumnVal[row?.key]?.join(", ")
											: filterColumnVal?.[row?.key]
									}`}
									size="small"
								/>
							);
						})}
					</Box>
					<Box>
						<Button
							variant="contained"
							sx={{ textTransform: "capitalize", mr: 1 }}
							size="small"
							onClick={handleAddColumnClick}
							startIcon={<PlaylistAddRounded />}>
							Manage Columns
						</Button>
						{/* <Button
							variant="contained"
							size="small"
							sx={{ textTransform: "capitalize" }}
							onClick={handleDownloadClick}
							startIcon={<FileDownloadRounded />}>
							Download
						</Button> */}
					</Box>
				</Stack>
				{/* right section */}
				<Box width="68%"></Box>
			</Box>
			<Box display="flex" justifyContent="space-between" alignItems="center" pt={1}>
				<Box display="flex" alignItems="center">
					<Typography variant="h6">Images</Typography>
					<Switch checked={displayImg} onChange={(e) => handleImageSwitchChange(e.target.checked)} sx={{ mt: 1 }} />
				</Box>
				<Box display="flex" alignItems="center" columnGap={1}>
					<Typography variant="body1">
						Total: <span style={{ color: grey[700] }}>{tableStatusCount.total}</span>
					</Typography>
					<Divider orientation="vertical" flexItem />
					<Typography variant="body1">
						Published: <span style={{ color: green[600] }}>{tableStatusCount.published}</span>
					</Typography>
					<Divider orientation="vertical" flexItem />
					<Typography variant="body1" fontWeight={600}>
						Pending: <span style={{ color: "red" }}>{tableStatusCount.pending}</span>
					</Typography>
				</Box>
			</Box>

			<Stack width="100%" height={400}>
				<DataGrid
					rows={styles ? styles : []}
					key={displayImg}
					columns={styleTablColumns ?? []}
					sx={{
						height: "60vh",
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
						"& .MuiDataGrid-footer": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={displayImg ? 70 : 40}
					getRowId={(row) => row?.style_id}
					// showCellVerticalBorder
					onRowClick={(params, e) => handleStyleSelect(params.row)}
					initialState={{
						pagination: {
							paginationModel: { pageSize: pageLimit },
						},
						columns: {
							columnVisibilityModel: {
								[styleImageColumn.key]: displayImg,
							},
						},
					}}
					// loading={loading}
					disableRowSelectionOnClick
					// pageSizeOptions={[10, 50]}
					rowCount={tableStatusCount?.total ?? 20}
					loading={loading}
					paginationMode="server"
					paginationModel={{ page, pageSize }}
					onPaginationModelChange={({ page, pageSize }) => {
						setPage(page);
						setPageSize(pageSize);
					}}
				/>
			</Stack>

			<FilterModal
				modal={filterModal}
				handleCloseModal={handleCloseFilterModal}
				filterColumns={filterColumns}
				setFilterColumns={setFilterColumns}
				filterColumnVal={filterColumnVal}
				setFilterColumnVal={setFilterColumnVal}
				localStorageStr={lsFabricTrimsFilterValStr}
			/>
			<AddColumnModal
				modal={addColumnModal}
				handleCloseModal={handleCloseAddColumnModal}
				attrColumns={attrColumns}
				setAttrColumns={setAttrColumns}
				localStorageStr={"fab_trims_column_Arr"}
			/>
			<FullScreenPopup
				key={selectedStyle}
				modal={editModal}
				setModal={setEditModal}
				selectedStyle={selectedStyle}
				styleStaticData={selectedStyleStaticData}
				allStyles={styles}
				setAllStyles={setStyles}
			/>
		</Stack>
	);
};

export default FabricAndTrims;
